import { Button } from "@components/ui/Button"
import { formatBasicDate } from "@utils/date-format"
import { Link } from "eddev/routing"
import { ReactNode } from "react"

type Props = {
  size?: number
  date?: string
  title?: ReactNode
  url?: string
  target?: string
  fileType?: string
}

export function FileDownload(props: Props) {
  const type = props.fileType ?? props.url?.split(".").pop()
  const date = props.date ? formatBasicDate(props.date) : ""
  const size = !props.size
    ? null
    : props.size < 1024 * 1024
      ? { value: props.size / 1024, unit: "KB" }
      : { value: props.size / 1024 / 1024, unit: "MB" }
  return (
    <Link
      className="group flex text-fg items-center hover:text-fg bg-bg border border-bg-mid hover:border-bg-high p-4 rounded-md"
      href={props.url}
      target={props.target}
    >
      <div className="flex flex-col gap-3 md:gap-2 flex-1 pl-2 md:pl-0">
        <div className="type-body-m text-pretty">{props.title}</div>
        <div className="flex gap-2 type-body-xs uppercase items-center">
          {/* Date */}
          {date && <span className="bg-bg-low px-[0.5em] py-[0.1em]">{date}</span>}
          {/* Type/Size */}
          {(type || size) && (
            <span>
              {[
                type,
                size && Intl.NumberFormat("en-US", { maximumFractionDigits: 1 }).format(size.value) + " " + size.unit,
              ]
                .filter(Boolean)
                .join(" ")}
            </span>
          )}
        </div>
      </div>
      <div className="flex items-center justify-center flex-none">
        <Button shape="icon" icon="download" variant="ghost" />
      </div>
    </Link>
  )
}
